<div class="container">
    <div class="section-title">
        <h2>Preise – Führerscheinklasse B</h2>
        <div class="bar"></div>
        <p>Transparente und faire Preise für deine Führerscheinausbildung – ohne versteckte Kosten. Alle Preise verstehen sich inklusive 19% MwSt.</p>
    </div>

    <div class="tab pricing-list-tab">
        <ul class="tabs">
            <li><a href="#">Einzelpreise</a></li>
            <li><a href="#">Gesamtpaket</a></li>
        </ul>

        <div class="tab_content">
            <!-- Einzelpreise -->
            <div class="tabs_item">
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Grundbetrag</h3>
                            </div>
                            <div class="price">
                                <sup>€</sup>400
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Anmeldung & Verwaltung</li>
                                <li><i class="fas fa-check"></i> Theorieunterricht (14 Einheiten)</li>
                                <li><i class="fas fa-check"></i> Persönliche Betreuung</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Fahrstunden</h3>
                            </div>
                            <div class="price">
                                <sup>€</sup>65 <sub>/45 Min</sub>
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Übungsstunde: €65</li>
                                <li><i class="fas fa-check"></i> Sonderfahrt: €65</li>
                                <li><i class="fas fa-check"></i> Individuelle Terminvereinbarung</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Prüfungen & Material</h3>
                            </div>
                            <div class="price">
                                <sup>€</sup>77,51 <sub>Theorie</sub>
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Theorieprüfung: €77,51</li>
                                <li><i class="fas fa-check"></i> Praxisprüfung: €203,07</li>
                                <li><i class="fas fa-check"></i> Lernmaterial: €50</li>
                                <li><i class="fas fa-times"></i> TÜV-Gebühr nicht enthalten</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Paketangebot (fiktiv, optionnel) -->
            <div class="tabs_item">
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-8">
                        <div class="single-pricing-table featured">
                            <div class="pricing-header">
                                <h3>Kompaktpaket – Theorie in 7 Tagen</h3>
                            </div>
                            <div class="price">
                                <sup>ab €</sup>1.699 <sub>(je nach Fahrstundenanzahl)</sub>
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Theorie in nur 7 Tagen</li>
                                <li><i class="fas fa-check"></i> Grundbetrag, Material, Fahrstunden</li>
                                <li><i class="fas fa-check"></i> Flexible Termine</li>
                                <li><i class="fas fa-check"></i> Persönliche Betreuung bis zur Prüfung</li>
                            </ul>

                            <div class="pricing-btn">
                                <a href="#kontakt" class="default-btn">Jetzt anfragen <span></span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>
